export enum ECurrency {
  USD = 'USD',
  AED = 'AED',
  RUB = 'RUB',
  UZS = 'UZS',
  INR = 'INR',
  THB = 'THB',
  VND = 'VND',
  USDT_TRC20 = 'USDT TRC20',
}

export const isoToECurrency = (str?: string) => {
  switch (str) {
    case '840':
      return ECurrency.USD
    case '784':
      return ECurrency.AED
    case '643':
      return ECurrency.RUB
    case '860':
      return ECurrency.UZS
    case '356':
      return ECurrency.INR
    case '764':
      return ECurrency.THB
    case '704':
      return ECurrency.VND
    case 'USDT_TRC20':
      return ECurrency.USDT_TRC20
    default:
      return null
  }
}
